import type { HTMLAttributes } from "react";
import { cx } from "./cx";
import { formatMoney, formatMsisdn, shortId } from "./format";

/** 行内等宽片段：UUID 末 8 位、错误码、配置版本。 */
export function Code({ className, ...rest }: HTMLAttributes<HTMLElement>) {
  return <code className={cx("ax-code", className)} {...rest} />;
}

/** UUID 只显示末 8 位（v7 的前缀是时间戳，同一时段相同），完整值在 title。 */
export function ShortId({ id }: { id: string }) {
  return <Code title={id}>{shortId(id)}</Code>;
}

export function Msisdn({ value, className }: { value: string; className?: string }) {
  return <span className={cx("ax-mono", className)}>{formatMsisdn(value)}</span>;
}

export function Money({ micro, currency, className }: { micro: number | string | bigint; currency?: string; className?: string }) {
  const negative = Number(micro) < 0;
  return <span className={cx("ax-money", className)} style={negative ? { color: "var(--danger)" } : undefined}>{formatMoney(micro, currency)}</span>;
}
